import { useTimeZone } from 'next-intl'

import { useFullLocale } from '@/shared/locale'

import type {
  CommonDateFormatter,
  CommonDateFormatterWithTimeZone,
} from './commonDateFormatter.common'
import { getFormatDate } from './commonDateFormatter.common'

export function useCommonDateFormatter(withTimeZone: string): {
  formatDate: CommonDateFormatterWithTimeZone
}
export function useCommonDateFormatter(): { formatDate: CommonDateFormatter }
// eslint-disable-next-line func-style
export function useCommonDateFormatter(withTimeZone?: string): {
  formatDate: CommonDateFormatterWithTimeZone | CommonDateFormatter
} {
  const locale = useFullLocale()
  const timeZone = useTimeZone()

  if (withTimeZone) {
    return { formatDate: getFormatDate<true>(locale, withTimeZone) }
  }
  return {
    formatDate: getFormatDate<false>(locale, timeZone),
  }
}
